import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper, Tooltip,
  Typography,
} from "@deere/fuel-react";
import "../assets/Campaigns.scss";
import { ListItemPrimary } from "../shared/ListItemPrimary";
import { ListItemSecondary } from "../shared/ListItemSecondary";
import { toCapitalize } from "../shared/utils";
import {Block} from "@material-ui/icons";

export const CampaignStakeholderCard = ({
  currentData,
  onHandleEdit = () => {},
  isPublish = false,
}) => {
  const [stakeholders, setStakeholders] = useState([]);
  const [stakeholderType, setStakeholderType] = useState([]);

  useEffect(() => {
    let updatedArr = [];
    const checkDataExists = (id) => {
      return (
        updatedArr &&
        updatedArr.find((ele) => {
          return ele.id === id;
        })
      );
    };
    // eslint-disable-next-line array-callback-return
    currentData.stakeholders.map((arrItem) => {
      let obj = {};
      if (checkDataExists(arrItem.user.racfID)) {
        const currentItem = updatedArr.find((ele) => {
          return ele.id === arrItem.user.racfID;
        });
        currentItem.roles.push(arrItem.role.description);
        obj = currentItem;
      } else {
        obj = {
          id: arrItem.user.racfID,
          user: arrItem.user,
          roles: [arrItem.role.description],
        };
      }
      updatedArr.push(obj);
    });
    const rolesArray = [...new Set(updatedArr.map((item) => item.roles))];
    setStakeholderType([...new Set(rolesArray.flat())]);
    setStakeholders([
      ...new Map(
        updatedArr.map((item) => [item["user"]["racfID"], item])
      ).values(),
    ]);

    return () => {
      setStakeholders([]);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentData]);

  return (
    <Grid item md={6}>
      <Box mt={6} mr={6}>
        <Card>
          <CardContent>
            <Box m={2}>
              <Grid container alignItems="flex-start" spacing={6}>
                <Grid item md={11}>
                  <Typography variant="h3" gutterBottom display="inline">
                    {`${stakeholders.length} Stakeholder${
                      stakeholders.length === 1 ? "" : "s"
                    }`}
                  </Typography>
                  <Typography
                    color="tertiary"
                    size="md"
                    component="p"
                    gutterBottom
                    display="inline"
                  >
                    {`  (${stakeholderType.length} Stakeholder type${
                      stakeholderType.length === 1 ? "" : "s"
                    })`}
                  </Typography>
                </Grid>
                <Grid item md={1}>
                  {!isPublish && (
                    <Button variant="text" onClick={() => onHandleEdit(2)}>
                      Edit
                    </Button>
                  )}
                </Grid>
                <Grid item md={12}>
                  <Paper>
                    <List
                      disablePadding
                      component="nav"
                      aria-label="stakeholder card"
                    >
                      {stakeholders.length > 0 &&
                        stakeholders.map((stakeholder, index) => {
                          return (
                            <ListItem divider key={index}>
                              <ListItemText
                                primary={
                                  <ListItemPrimary
                                    content={`${toCapitalize(
                                      stakeholder.user.lastName
                                    )},${toCapitalize(
                                      stakeholder.user.firstName
                                    )}  - ${stakeholder.user.racfID}`}
                                  />
                                }
                                secondary={
                                  <ListItemSecondary
                                    content={`${stakeholder.roles.join(", ")}`}
                                  />
                                }
                              />
                              {stakeholder.user.userStatus && stakeholder.user.userStatus !== "ACTIVE" && <Tooltip title={"Invalid User ID"}><Block htmlColor={"red"} /></Tooltip>}
                            </ListItem>
                          );
                        })}
                    </List>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Grid>
  );
};
